{
  "page": {
    "title": "Reports",
    "ariaLabel": "Report types"
  },
  "filters": {
    "timeRange": "Time range",
    "employee": "Employee",
    "allEmployees": "All employees",
    "employeeRequired": "Employee *",
    "selectEmployee": "Select employee…"
  },
  "templates": {
    "attendanceSummary": {
      "label": "Attendance Summary",
      "description": "Daily attendance overview with in/out times and hours worked per employee."
    },
    "payroll": {
      "label": "Payroll",
      "description": "Payroll breakdown with hours, rates, and total pay per employee."
    },
    "dailyTimesheet": {
      "label": "Daily Timesheet",
      "description": "Detailed punch-by-punch record for each employee per day."
    },
    "lateAbsent": {
      "label": "Late & Absent",
      "description": "Employees who arrived late or were absent during the period."
    },
    "overtime": {
      "label": "Overtime",
      "description": "Summary of overtime hours and pay for the selected period."
    },
    "employeeActivity": {
      "label": "Employee Activity",
      "description": "Full activity log including all punch events for each employee."
    },
    "attendanceGrid": {
      "label": "Attendance Grid",
      "description": "Month matrix showing each employee's worked hours, vacation days, leave days, and absences."
    },
    "hiring": {
      "label": "Hiring",
      "description": "Employees hired during the selected period, with hire date and contact details."
    }
  },
  "export": {
    "csv": "Export CSV",
    "excel": "Export Excel",
    "pdf": "Export PDF",
    "downloadFailed": "Download failed. Please try again.",
    "dismiss": "Dismiss"
  },
  "attendanceGrid": {
    "monthLabel": "Month",
    "employeeColumn": "Employee",
    "cell": {
      "vacation": "V",
      "leave": "A",
      "holiday": "H",
      "present": "P"
    },
    "legend": {
      "worked": "Worked (start–end)",
      "vacation": "Vacation",
      "leave": "Absent",
      "holiday": "Holiday",
      "off": "Non-working day",
      "present": "Present",
      "workedHours": "Worked (hours at work)"
    },
    "view": {
      "label": "Display",
      "times": "In / out",
      "hours": "Hours at work"
    }
  },
  "preview": {
    "selectEmployee": "Select an employee to preview this report",
    "selectEmployeeHint": "Use the employee dropdown in the filter panel above.",
    "failedToLoad": "Failed to load report data",
    "failedToLoadHint": "Check your connection and try again.",
    "noData": "No data for the selected period",
    "noDataHint": "Adjust the date range or employee filter and try again.",
    "truncatedRows": "Showing first 50 of {{total}} rows. Export to see all data."
  },
  "advance": {
    "addButton": "Add Advance",
    "dialogTitle": "New Salary Advance",
    "dateNotice": "The advance is recorded with today's date.",
    "employeeLabel": "Employee",
    "employeePlaceholder": "Select employee",
    "amountLabel": "Amount (AMD)",
    "noteLabel": "Note (optional)",
    "errors": {
      "employeeRequired": "Select an employee.",
      "amountInvalid": "Enter an amount greater than 0."
    },
    "toasts": {
      "created": "Advance recorded.",
      "createFailed": "Failed to record the advance. Please try again.",
      "deleted": "Advance deleted.",
      "deleteFailed": "Failed to delete the advance. Please try again."
    },
    "listTitle": "Advances — {{name}}",
    "listEmpty": "No advances in this period.",
    "listTotal": "Total",
    "deleteAria": "Delete advance",
    "confirmDelete": "Delete this advance?",
    "dateLabel": "Date"
  },
  "columnToggle": {
    "hide": "Hide column",
    "show": "Show column"
  },
  "groups": {
    "collapse": "Collapse columns",
    "expand": "Expand columns",
    "late": {
      "title": "Lateness",
      "hours": "Hours",
      "deduction": "Deduction (AMD)"
    },
    "earlyLeave": {
      "title": "Early Leave",
      "hours": "Hours",
      "deduction": "Deduction (AMD)"
    },
    "absence": {
      "title": "Absence / unpaid leave",
      "days": "Days",
      "deduction": "Deduction (AMD)"
    },
    "overtime": {
      "title": "Overtime",
      "hours": "Hours",
      "rate": "Rate",
      "pay": "Pay (AMD)"
    }
  },
  "inlineEdit": {
    "saved": "Saved.",
    "saveFailed": "Failed to save. Please try again.",
    "spSalaryHint": "Applies from {{month}} onward; earlier months keep their ՍՊԸ."
  }
}
